import { parseHTML, replaceNodeChildren } from '../../utils/dom'
import { BaseComponent } from '../../components/base-component'
import { hideElement, showElement } from '../../utils/dom'
import { $el, $list } from 'src/scripts/utils/utils'

const LOADING_OVERLAY_SELECTOR = '.loading-overlay'

export class CartRelatedProducts extends BaseComponent {
  prevUrl: string

  mountComponent(): void {
    this.loadProducts()
  }

  erase(): void {
    this.replaceChildren()
    this.setReady(false)
  }

  loadProducts(): Promise<void> {
    if (this.prevUrl === this.dataset.url) {
      return
    }

    this.prevUrl = this.dataset.url

    if (!this.dataset.url) {
      return
    }

    this.showPreloader()

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        this.hidePreloader()
        this.updateByHTML(parseHTML(text))
      })
      .catch(() => {
        console.log('Error in cart related products')
      })
  }

  updateByHTML = (node: Document): void => {
    const recommendations = $el(`#${this.id}`, node)

    replaceNodeChildren(this, recommendations)

    const products = $list('vertical-product-card', this)

    this.setReady(products.length > 0)
  }

  setReady(isReady: boolean): void {
    this.toggleAttribute('is-ready', isReady)
  }

  showPreloader(): void {
    const loadingOverlay = $el(LOADING_OVERLAY_SELECTOR, this)
    showElement(loadingOverlay)
  }

  hidePreloader(): void {
    const loadingOverlay = $el(LOADING_OVERLAY_SELECTOR, this)
    hideElement(loadingOverlay)
  }
}
